export const sendField = (payload, event) => ({
  type: 'SEND_FIELD',
  payload,
  event,
});

export const sendFieldEmulator = (payload, event) => ({
  type: 'SEND_FIELD_EMULATOR',
  payload,
  event,
});
